import request from "@/utils/request";

export default function agentEditChildAgent(params) {
    return request({
        url: `/user/agent/agentEditChildAgent`,
        method: 'post',
        params
    })
}
